export const LOCALES = [
    { name: 'ru-RU', currency: 'RUB', shortName: 'ru' },
    { name: 'en-US', currency: 'USD', shortName: 'en' },
];
